
// this file is automatically generated by git.version.ts script
export const versions = {
  version: '0.0.0',
  revision: 'a2a14fb',
  branch: 'HEAD'
};